import { render, staticRenderFns } from "./information-row.vue?vue&type=template&id=01f4493e&"
import script from "./information-row.vue?vue&type=script&lang=ts&"
export * from "./information-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports